import { ThrowStmt } from '@angular/compiler';
import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ProService } from 'src/app/db/models/pro-services';
import { HandleType, ServiceHandle } from 'src/app/db/models/service-handle';
import { User } from 'src/app/db/models/user';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { HandlesService } from 'src/app/services/handles.service';
import { ProfessionalServiceService } from 'src/app/services/professional-service.service';

@Component({
  selector: 'app-handle-edit',
  templateUrl: './handle-edit.component.html',
  styleUrls: ['./handle-edit.component.css']
})
export class HandleEditComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title = 'Service Handle';
  title_sub = 'Service Handle Actions'

  hform: FormGroup;

  handle = new ServiceHandle();
  handles : ServiceHandle[];
  private sub: Subscription;
  user: User;
  serviceId: string;
  loading = false;
  is_edit: boolean;

  handleTypes: HandleType[];

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
              private router: Router,
              private route: ActivatedRoute,
              private service: HandlesService,
              private pservice: ProfessionalServiceService,
              private spinner: NgxSpinnerService,
              private authenticate:AuthenticationService,
              private notify: ToastrService)
  {
    this.validationMessages = {
      handleDetail: {
        required: 'Copy Link name from selected handle app and paste here'
      },
      handleTypeId: {
        required: 'Select one'
      }
    }

    this.genericValidator = new GenericValidator(this.validationMessages);
    this.authenticate.currentUser.subscribe(x => this.user = x);
  }

  ngOnInit() {

    this.createFrom();
    this.getHandleTypes();

    //on Page Initialize get me the id parameter from the route
    this.sub = this.route.paramMap.subscribe(
      params => {
        const id = params.get('id');
        // this.serviceId = id;
        this.getHandle(id)
      }
    )

  }

  createFrom() {
    this.hform = this.fb.group({
      handleDetail: [null, Validators.required],
      handleTypeId: [null, Validators.required]
    })
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.hform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.hform);
    });
  }

  getHandleTypes(){
    this.service.getAllHandleTypes().subscribe(
      data => {
        this.handleTypes = data;
      }
    )
  }

  get handleDetail() {
    return this.hform.controls.handleDetail as FormControl;
  }

  get handleTypeId() {
    return this.hform.controls.handleTypeId as FormControl;
  }

  mapEntity(): void {
    this.handle.handleDetail = this.handleDetail.value;
    this.handle.handleTypeId = this.handleTypeId.value;
    this.handle.serviceId = this.user.serviceId;
  }

  saveData(){
    this.loading = true;
    if (this.hform.valid) {
        this.mapEntity();
        // console.log(this.handle);
        if (this.handle.id != null) {
          this.service.updateServiceHandle(this.handle)
          .subscribe({
            next: () => {
              this.spinner.hide();
              this.successNotification();
            },
            error: err => {
              this.spinner.hide();
              this.errorNotification();
            }
          })
        } else {
          this.service.addServiceHandle(this.handle)
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.successNotification();
          },
          error: err => {
            this.spinner.hide();
            this.errorNotification();
          }
        })
       }
    }
  }

  successNotification(){
    this.notify.success('Successful');
    this.router.navigate([`/profile/${this.user.id}`])
  }

  errorNotification(){
    this.notify.warning('Cannot add Handle');
    this.router.navigate([`/profile/${this.user.id}`])
  }

  getHandle(id:string) {
    this.service.getHandleDetail(id).subscribe({
      next: (res: ServiceHandle) => this.displayServiceHandle(res),
      error: err => console.log("Form Reset")
    })
  }

  displayServiceHandle(data: ServiceHandle): void {
    if(this.hform){
      this.hform.reset();
    }
    this.handle = data;
    if(this.handle === null){
      this.title = 'Service Handle';

    } else {
      this.title = 'Service Handle Update';
      this.is_edit == true;
    }
    this.hform.patchValue({
      handleDetail: data.handleDetail,
      handleTypeId: data.handleTypeId
    });
  }

}
